import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import packageJson from '../../../../package.json';

const FRONT_VERSION = packageJson.version;
import { fetchBackendVersion } from '../services/versionApi';

type State =
	| { status: 'loading' }
	| { status: 'ok'; version: string }
	| { status: 'mismatch'; frontVersion: string; backVersion: string }
	| { status: 'error'; frontVersion: string };

export function VersionTag() {
	const [state, setState] = useState<State>({ status: 'loading' });

	useEffect(() => {
		fetchBackendVersion()
			.then(({ version: backVersion }) => {
				if (backVersion === FRONT_VERSION) {
					setState({ status: 'ok', version: FRONT_VERSION });
				} else {
					setState({
						status: 'mismatch',
						frontVersion: FRONT_VERSION,
						backVersion,
					});
				}
			})
			.catch(() => {
				setState({ status: 'error', frontVersion: FRONT_VERSION });
			});
	}, []);

	if (state.status === 'loading') {
		return (
			<span className="text-xs text-gray-500">Corelys v{FRONT_VERSION}</span>
		);
	}

	if (state.status === 'ok') {
		return (
			<span className="text-xs text-gray-400">Corelys v{state.version}</span>
		);
	}

	if (state.status === 'mismatch') {
		return (
			<span
				className="text-xs text-yellow-400 flex items-center gap-1"
				title={`Désynchronisation détectée — Front : ${state.frontVersion} / Back : ${state.backVersion}`}
			>
				<FontAwesomeIcon icon={faTriangleExclamation} className="shrink-0" />
				<span>
					FE&nbsp;v{state.frontVersion}&nbsp;/&nbsp;BE&nbsp;v{state.backVersion}
				</span>
			</span>
		);
	}

	return (
		<span
			className="text-xs text-red-400 flex items-center gap-1"
			title="Impossible de contacter le backend pour vérifier la version"
		>
			<FontAwesomeIcon icon={faTriangleExclamation} className="shrink-0" />
			<span>Corelys v{state.frontVersion}</span>
		</span>
	);
}
